import api from '../utils/api';

/**
 * Get all tools
 */
export const getAllTools = async () => {
    try {
        const response = await api.get('/tools');
        return response.data;
    } catch (error) {
        console.error('Error fetching tools:', error);
        throw error;
    }
};

/**
 * Get tool by ID
 */
export const getToolById = async (toolId) => {
    try {
        const response = await api.get(`/tools/${toolId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching tool:', error);
        throw error;
    }
};